import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

const APP_ICON_INLINE = '/app-icons/web/icon-192.png';
const APP_ICON_STACKED = '/app-icons/web/icon-512.png';

@Component({
  selector: 'app-brand-logo',
  imports: [RouterLink],
  styles: `
    .brand-logo--stacked {
      flex-direction: column;
      gap: 2px;
    }

    .brand-logo--stacked .brand-mark {
      margin-bottom: -14px;
    }

    .brand-logo--stacked .brand-wordmark {
      line-height: 1;
    }

    .brand-wordmark-gradient {
      background: linear-gradient(135deg, #0ea5e9 0%, #2563eb 52%, #4f46e5 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
    }

    .brand-mark {
      display: block;
      flex-shrink: 0;
      object-fit: contain;
    }

    .brand-mark--app-icon {
      border-radius: 22%;
    }
  `,
  template: `
    <a
      [routerLink]="link"
      class="inline-flex items-center no-underline"
      [class]="hostClass"
      [class.brand-logo--stacked]="layout === 'stacked'">
      <img
        [src]="resolvedMarkSrc"
        alt=""
        class="brand-mark brand-mark--app-icon"
        [style.height.px]="markSize"
        [style.width.px]="markSize" />
      @if (showWordmark) {
        @if (light) {
          <span class="brand-wordmark font-bold tracking-tight text-white" [style.font-size.px]="wordmarkSize">
            GoCareMo
          </span>
        } @else {
          <span
            class="brand-wordmark brand-wordmark-gradient font-bold tracking-tight"
            [style.font-size.px]="wordmarkSize">
            GoCareMo
          </span>
        }
      }
    </a>
  `,
})
export class BrandLogo {
  @Input() link = '/';
  @Input() showWordmark = true;
  @Input() light = false;
  @Input() layout: 'inline' | 'stacked' = 'inline';
  @Input() markSize = 44;
  @Input() wordmarkSize = 22;
  @Input() hostClass = 'items-center';
  /** Override default app icon; otherwise uses icon-192 (inline) or icon-512 (stacked). */
  @Input() markSrc?: string;

  get resolvedMarkSrc(): string {
    if (this.markSrc) {
      return this.markSrc;
    }

    return this.layout === 'stacked' ? APP_ICON_STACKED : APP_ICON_INLINE;
  }
}
